import { AppState, Dispatch } from '../../../types'
import * as selectors from '../selectors'
import { selectors as authSelectors } from '../../../lifecycle/auth'
import { connect } from 'react-redux'
import * as actions from '../actions'
import './CustomDashboardList.css'
import CustomDashboardList, { EventProps, ValueProps } from './CustomDashboardList';

const mapProps = (state: AppState): ValueProps => ({
  hasEditRole: authSelectors.hasEditRole(state),
  dashboards: selectors.getFilteredDashboards(state),
  loading: selectors.isLoading(state),
  query: selectors.getQuery(state),
});

const mapDispatch = (dispatch: Dispatch): EventProps => ({
    fetchDashboards: () => dispatch(actions.fetchDashboards()),
    queryChange: (query: string) => dispatch(actions.queryChange(query))
});

export default connect(mapProps, mapDispatch)(CustomDashboardList)
